const nationalities = require("@orgware/i18n-nationality");
nationalities.registerLocale(
  require("@orgware/i18n-nationality/langs/en.json"),
);
nationalities.registerLocale(
  require("@orgware/i18n-nationality/langs/hu.json"),
);

export const getNationality = (
  nationalityCode: string,
  locale: string,
): string => {
  /**
    
    const list = Object.keys(nationalities.getNames(locale));
    const coded = list.map(item => {
        const code = nationalities.alpha2ToAlpha3(item);
        const name = nationalities.getName(code, locale);
        return { code, name };
    });
    */
  return nationalities.getName(nationalityCode, locale);
};

export default getNationality;
